import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Input from "./../../../common/input";
import getService from "../../../services/getService";
import postService from "../../../services/postService";
import { toast } from "react-toastify";

const HeadingForm = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [account, setAccount] = useState({
    id: "",
    title: "",
  });

  const handleChange = ({ currentTarget: input }) => {
    const accounts = { ...account };
    accounts[input.name] = input.value;
    setAccount(accounts);
  };

  const PopulateForm = async () => {
    try {
      const Id = params.id;
      if (Id === "new") return;

      const collection = await getService.handleHeading();
      const data = await getService.getData(collection, Id);
      setAccount(mapToViewModel(data));
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    PopulateForm();
  }, []);

  const mapToViewModel = (data) => {
    return {
      id: data.id,
      title: data.title,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await postService.PostHeading(account);
    } catch (error) {
      toast.error(error);
    }
  };

  const { title } = account;

  return (
    <>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-bd lobidrag">
            <div class="panel-heading">
              <div class="panel-title">
                <h4>Add/Update Heading </h4>
              </div>
            </div>
            <div class="panel-body">
              <form onSubmit={handleSubmit}>
                <div class="row">
                  <div className="col-sm-12 mt-2">
                    <Input
                      name="title"
                      label="Title"
                      value={title}
                      onChange={handleChange}
                    />
                  </div>

                  <div class="col-md-1 offset-md-11">
                    <button className="btn btn-success">Save</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeadingForm;
